import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import LinesChartContainer from 'modules/Charts/Lines/LinesChartContainer'
import MapChartContainer from 'modules/Charts/Map/MapChartContainer'
import AppTools from 'utils/app/appTools'
import IndicatorTools from 'utils/indicators/indicatorTools'

import Loading from 'components/Loading'
import Error from 'components/Error'

class PanelDimensionContainer extends Component {
	constructor(props) {
		super(props)

		const {
			intl: { formatMessage }
		} = props
		this.formatMessage = formatMessage

		this.state = {
			loading: true,
			error: false,
			levelIndicators: []
		}
	}

	componentDidMount() {
		if (this.props.level !== 0) {
			let levelIndicators = IndicatorTools.getIndicatorsFromLevel(this.props.dimension)

			this.setState({
				levelIndicators,
				loading: false,
				error: false
			})
		} else {
			this.setState({
				loading: false,
				error: false
			})
		}
	}

	renderChart = ( indicator ) => {
		let chart = null;

		switch (this.props.chartTypeFilter) {
			case 'evolutionAbsolute':
				chart = this.renderLinesChart(indicator)
				break
			case 'map':
				chart = this.renderMapChart(indicator)
				break
			default:
				chart = null
				break
		}

		return chart;
	}

	composeCharts = ( subdimension, indicators ) => {
		let charts = [];

		let numberOfRows = Math.ceil(indicators.length / 2);
		for (let i = 0; i < numberOfRows; i++) {
			charts.push(
				<div className="row" key={`row${subdimension}.${i}`}>
					{this.renderChart( indicators[i * 2] )}
					{indicators[i * 2 + 1] ? this.renderChart( indicators[i * 2 + 1] ) : null}
				</div>
			);
		}

		return charts;
	}

	renderLinesChart(indicator) {
		return <LinesChartContainer indicator={indicator} />
	}

	renderMapChart(indicator) {
		return <MapChartContainer indicator={indicator} />
	}

	renderAllCharts(indicator) {
		return (
			<React.Fragment>
				<LinesChartContainer indicator={indicator} layer={this.props.layer} />
				<MapChartContainer indicator={indicator} layer={this.props.layer} />
			</React.Fragment>
		)
	}

	renderPanelSubsection = (dimension, subdimension, indicators) => {
		let title = AppTools.getSubDimensionTitle(dimension, subdimension); // `Subsection ${subdimension} title`;
		let key = `${dimension}.${subdimension}`;

		return <React.Fragment key={key}>
			{/* <p className={`ork-epigraph ork-epigraph--grey ${subdimension === 0 ? 'ork-u-mt-2' : 'ork-u-mt-4'} ork-u-mb-2`} key={`row${subdimension}`}> */}
				<h3>{title}</h3>
			{/* </p> */}
			{this.composeCharts(subdimension, indicators)}
		</React.Fragment>
	}

	renderIfAllOK() {
		let renderingComponent = null
		if (this.state.error) {
			renderingComponent = <Error />
		} else if (this.state.loading) {
			renderingComponent = <Loading />
		} else {
			let subsections = [];

			if (this.props.level !== 0) {
				this.state.levelIndicators.forEach((subLevelIndicators, subLevel) => {
					subsections.push(this.renderPanelSubsection(this.props.dimension, subLevel, subLevelIndicators))
				});
			} else {
				subsections.push(
					<div className="row" key={`row${1}`}>
						{this.composeCharts({ indicator: this.props.indicator })}
					</div>
				)
			}
			renderingComponent = subsections;
		}

		return renderingComponent
	}

	render() {
		return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(PanelDimensionContainer)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/PanelDimensionContainer/PanelDimensionContainer.jsx